// ============================================================
// gradient.js — Utilidad DRY: gradient stops → CSS string
// Centraliza la lógica que estaba duplicada en:
//   - editor/tools.js (updateLivePreview + renderUI)
//   - editor/unsplash.js (resolverImagenesUnsplash)
// ============================================================

import { hexToRgb } from './contrast.js';

/**
 * Convierte array de stops [{color, opacity, position}] a string CSS gradient.
 * @param {Array}  stops     - Gradient stops del formato data-bg-gradient
 * @param {string} direction - CSS direction (ej: '180deg', '90deg')
 * @returns {string} CSS linear-gradient string, o '' si stops vacío/inválido
 */
export function gradientStopsToCss(stops, direction = '180deg') {
    if (!Array.isArray(stops) || stops.length === 0) return '';
    const sorted = [...stops].sort((a, b) => a.position - b.position);
    const strs = sorted.map(s => {
        const [r, g, b] = hexToRgb(s.color || '#000000');
        return `rgba(${r}, ${g}, ${b}, ${s.opacity / 100}) ${s.position}%`;
    });
    return `linear-gradient(${direction}, ${strs.join(', ')})`;
}

/**
 * Lee data-bg-gradient del DOM, parsea JSON, devuelve CSS string.
 * Lectura directa de data-attribute → sin getComputedStyle → sin layout reflow.
 * @param {HTMLElement} section   - Elemento con data-bg-gradient
 * @param {string}      direction - CSS direction
 * @returns {string} CSS gradient string o '' si no existe/error
 */
export function readGradientFromAttr(section, direction = '180deg') {
    try {
        // Sin `?.`: lo importa `utils/velo.js`, que los tests cargan en node 12.
        const raw = section && section.getAttribute('data-bg-gradient');
        if (!raw) return '';
        return gradientStopsToCss(JSON.parse(raw), direction);
    } catch {
        return '';
    }
}
